import {
  CONSTANTSSTATUS,
  CONSTSFGENTYPE,
} from './../dialog-edit-appointment/flags.const';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from '@drl/core/auth/models/user.model';
import { ComponentBase } from '@drl/core/component-base';
import { GetAppoinmentModel } from '@drl/shared/models';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { AppoinmentService } from '../appoinment.service';
import { DialogUpdateComponent } from '../dialog-update/dialog-update.component';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { UserStatus, userStatusTypesMap } from '@drl/core/enums/user-status.enum';
import { environment } from '@drl/env/environment';

@Component({
  selector: 'app-nurshing-note',
  templateUrl: './nurshing-note.component.html',
  styleUrls: ['./nurshing-note.component.scss'],
})
export class NurshingNoteComponent extends ComponentBase {
  readonly CONSTANTS = CONSTANTSSTATUS;
  readonly CONSTGENTYPE = CONSTSFGENTYPE;
  readonly brand = environment.brand;
  user: GetAppoinmentModel;
  nurshingNotesForm: FormGroup;
  careGiverId;
  AppointmentId;
  loading = false;
  careGiverGroupDetails;
  dateTimeDetails;
  careGiverDetails;
  errorLbl: string;
  IsEdit = true;
  attendeeDetails;
  public ptsImageUrl;
  public ptsImageUrlNursingNote;
  users: User[] = [];
  ptsDetailsById;
  externalId;
  age;
  appointmentId;
  guestAge;
  guestGender;
  disableSubmitButton = false;
  alternativeContactDetails;
  attendeeDefaultImage = '../../../../assets/patient-avatar.png';
  statuses = [];
  userRemovalConfirmationMsg: string;
  userDeleteSuccessMsg: string;
  userSavedMsg: string;
  successLbl: string;
  maleTextLbl: string;
  femaleTextLbl: string;
  otherLbl: string;
  constructor(
    private readonly formBuilder: FormBuilder,
    public dialogRef: NbDialogRef<NurshingNoteComponent>,
    public readonly patientService: AppoinmentService,
    private readonly router: Router,
    private readonly dialogService: NbDialogService,
    private readonly toastrService: ToastrService,
    protected readonly translateSvc: IpsTranslateService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;

  ngOnInit() {
    this.getTranslations();
    this.createNurshingNoteFrom();
    if (this.user.patientImageUrl != null && this.user.patientImageUrl) {
      this.ptsImageUrlNursingNote = this.user.patientImageUrl;
    } else if (this.user.patientImg != null && this.user.patientImg) {
      this.ptsImageUrlNursingNote = this.user.patientImg;
    } else {
      this.ptsImageUrlNursingNote = this.attendeeDefaultImage;
    }
    this.getPatientDetails();
    this.appointmentId = this.user.id;
    if (this.user.patientType === 'guest_patient') {
      this.guestAgeGender(this.user.id);
    }
    // this.getAlternativeEmailAndMob(this.appointmentId);// Commenting for MVP
    this.getAttendeeList(this.AppointmentId);
  }
  createNurshingNoteFrom() {
    this.nurshingNotesForm = this.formBuilder.group({
      nurshingNote: [''],
    });
  }
  /*  getAlternativeEmailAndMob(val: string) {
     const body = {
       appointmentId: val,
     };
     this.patientService.getAlternativeEmailAndMob(body).subscribe(res => {
       this.alternativeContactDetails = res.responseResult;
     });
   } */ // Commenting for MVP
  guestAgeGender(guestID: number): void {
    const gID = {
      appointmentId: guestID,
    };
    this.patientService.getPatientsDetailsById(gID).subscribe(res => {
      this.guestAge = res.responseResult.age;
      this.guestGender = res.responseResult.gender;
    });
  }
  getPatientDetails() {
    this.loading = true;
    this.patientService.getPatients().subscribe(res => {
      this.ptsDetailsById = res;
      this.ptsDetailsById = this.ptsDetailsById.find(
        x => x.id === this.user.patientId,
      );
      this.externalId = this.ptsDetailsById.externalId;
      this.age = this.ageFromDateOfBirthday(this.ptsDetailsById.dob);
      this.getCaregiverGroup(this.ptsDetailsById.careGroupId);
      this.loading = false;
    });
  }
  public ageFromDateOfBirthday(dateOfBirth): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  saveNurshingNote() {
    this.disableSubmitButton = true;
    const body = {
      appointmentId: this.AppointmentId,
      note: this.nurshingNotesForm.value.nurshingNote,
    };
    this.patientService.saveNurshingNotes(body).subscribe(res => {
      this.nursingNoteSuccessPopUp(true);
    });
  }
  redirectToCalender() {
    this.dialogRef.close();
    this.router.navigateByUrl('main/care-central');
  }
  getCaregiverGroup(body) {
    this.loading = true;
    this.patientService.getCaregiverGroup(body).subscribe(res => {
      this.careGiverGroupDetails = res;
      this.loading = false;
    });
  }
  getDateTimeDetailsById(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getDateTimeById(body).subscribe(res => {
      this.dateTimeDetails = res.responseResult;
    });
  }

  getAttendeeList(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAttendeeList(body).subscribe(res => {
      this.attendeeDetails = res.responseResult;
    });
  }
  getCaregiver(body) {
    this.loading = true;
    this.patientService.getCaregiver(body).subscribe(res => {
      this.careGiverDetails = res;
      this.ptsImageUrl = this.attendeeDefaultImage;
      if (this.careGiverDetails.photoUrl != null) {
        this.ptsImageUrl = this.careGiverDetails.photoUrl;
      }
      this.getCaregiverGroup(this.careGiverDetails.careGroupId);
      this.loading = false;
    });
  }
  nursingNoteSuccessPopUp(IsEdit) {
    this.dialogRef.close();
    const context = {
      IsEdit,
    };
    this._subscriptions.push(
      this.dialogService
        .open(DialogUpdateComponent, {
          context,
        })
        .onClose.subscribe(res => {
          if (res && res.error) {
            this.toastrService.error(res.message, this.errorLbl, {});
          }
        }),
    );
  }
  getTranslations() {
    this.translate
      .get([
        'userSavedMsgInt',
        'userRemovalConfirmationMsg',
        'userDeleteSuccessMsg',
        'successLbl',
        'errorLbl',
        'phoneNotValidMsg',
        'maleTextLbl',
        'femaleTextLbl',
        'otherLbl',
      ])
      .subscribe(res => {
        this.statuses = [
          userStatusTypesMap(this.translate)[UserStatus.REGISTERED],
          userStatusTypesMap(this.translate)[UserStatus.ACTIVE],
          userStatusTypesMap(this.translate)[UserStatus.INACTIVE],
        ];
        this.userSavedMsg = res.userSavedMsgInt;
        this.userRemovalConfirmationMsg = res.userRemovalConfirmationMsg;
        this.userDeleteSuccessMsg = res.userDeleteSuccessMsg;
        this.successLbl = res.successLbl;
        this.errorLbl = res.errorLbl;
        this.maleTextLbl = res.maleTextLbl;
        this.femaleTextLbl = res.femaleTextLbl;
        this.otherLbl = res.otherLbl;
      });
  }
  public getGenderLbl(genderLbl: string) {
    if (
      genderLbl === this.CONSTGENTYPE.Male ||
      genderLbl === this.CONSTGENTYPE.GMale
    ) {
      return this.maleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Female ||
      genderLbl === this.CONSTGENTYPE.GFemale
    ) {
      return this.femaleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Other ||
      genderLbl === this.CONSTGENTYPE.GOther
    ) {
      return this.otherLbl;
    } else {
      return null;
    }
  }
}
